<template>
  <div class="mb-5">
    <b-card-group 
      deck
      class="myBCardDeck mx-0 mb-4"
      style="column-gap: 30px"
    >
      <b-card
        v-for="(dData, dIndex) in dashboardData"
        v-if="upCards.includes(dIndex)"
        :key="dIndex"
        style="min-width: fit-content; margin-left: 0; margin-right: 0;"
      >
        <b-card-text 
          v-if="!loading && dData['by-users'] && dData['by-users'][currentUser.id]"
          :title="dData.description"
          style="white-space: nowrap;"
        >
          <div>
            <span 
              class="bigNumber"
              :class="dData['by-users'][currentUser.id].total > 0 ? 'cursor-pointer':''" 
              @click="showByIds(dData['by-users'][currentUser.id]['ids'], dData.openType, dData.title)">
              <template v-if="dData.openType == 'finance'">
                {{ dData['by-users'][currentUser.id].total | toShortCurrency }} <span style="font-weight: normal; font-size: 0.9rem">руб.</span>
              </template>
              <template v-else>
                {{ dData['by-users'][currentUser.id].total }}
              </template>
            </span> <span>{{ dData.inTime }}</span>
          </div>
          <!-- <b-progress :max="dData.goal"  :variant="dData.typeStatus">
            <b-progress-bar :value="dData.value" :label="`${((dData.value / dData.goal) * 100).toFixed(2)}%`"></b-progress-bar>
          </b-progress> -->
        </b-card-text>
        <b-card-text v-if="loading">
          <div class="my-2 font-size-14"><b-icon icon="arrow-repeat" scale="1.5" aria-label="Reload" class="mr-2" animation="spin"></b-icon>Обновляем...</div>
        </b-card-text>
        <template #footer>
          <small class="text-muted">{{ dData.title }}</small>
        </template>
      </b-card>
    </b-card-group>

    <b-card-group 
      deck v-if="!loading"
      class="mb-4"  
      style="row-gap: 30px;"     
    >
      <b-card
        v-for="(dData, dIndex) in dashboardData"
        v-if="upCharts.includes(dIndex)"
        :key="`chart_${dIndex}`"
        :style="(dData['by-users'] && dData['by-users'].length > 7) ? 'min-width: 100%;':'min-width: 45%;'"
      >
        <b-card-text v-if="!loading && dData['by-users']">
          <SalesChart
            :data="dData['by-users-chart']"
            :param="dData.title"
            :height="250"
          ></SalesChart>
        </b-card-text>
        <b-card-text v-if="loading">
          <div class="my-2 font-size-14"><b-icon icon="arrow-repeat" scale="1.5" aria-label="Reload" class="mr-2" animation="spin"></b-icon>Обновляем...</div>
        </b-card-text>
        <template #footer>
          <small class="text-muted">{{ dData.title }} {{ dData.inTime }}</small>
        </template>
      </b-card>
    </b-card-group>

    <b-card-group 
      class="mb-4" 
      deck 
      v-if="!loading && dashboardData.marginProfitCompany['by-users'] && dashboardData.marginProfitCompany['by-users'][currentUser.id]"
    >
      <b-card>
        <b-card-text>
          <vue-speedometer
            key="speedometer_one"
            :forceRender="true"
            :width="450"
            :height="260"
            style="display: flex; justify-content: center;"
            :value="toShortMillions(dashboardData.marginProfitCompany['by-users'][currentUser.id]['total'])"
            needleColor="steelblue"
            :needleTransitionDuration="4000"
            needleTransition="easeElastic"
            currentValueText="Личная МП: ${value} млн"
            textColor="${textColor}"
            :customSegmentStops="[0, toShortMillions(dashboardData.marginProfitCompany['by-departments'][workWithDepartmentId]['total'])]"
            :minValue="0"
            :maxValue="toShortMillions(dashboardData.marginProfitCompany['by-departments'][workWithDepartmentId]['total'])"
            :segmentColors='["#E57A27", "#FFD700", "#90EE90", "#0F6348"]'
          />
        </b-card-text>
        <template #footer>
          <small class="text-muted">Личная МП к МП отдела</small>
        </template>
      </b-card>
      <b-card>
        <b-card-text>
          <vue-speedometer
            key="speedometer_two"
            :forceRender="true"
            :width="450"
            :height="260"
            style="display: flex; justify-content: center;"
            :value="toShortMillions(dashboardData.marginProfitCompany['by-departments'][workWithDepartmentId]['total'])"
            needleColor="steelblue"
            :needleTransitionDuration="4000"
            needleTransition="easeElastic"
            currentValueText="МП отдела: ${value} млн"
            textColor="${textColor}"
            :customSegmentStops="[0, toShortMillions(dashboardData.marginProfitCompany['items']['total'])]"
            :minValue="0"
            :maxValue="toShortMillions(dashboardData.marginProfitCompany['items']['total'])"
            :segmentColors='["#0F6348", "#E57A27", "#FFD700", "#90EE90"]'
          />
        </b-card-text>
        <template #footer>
          <small class="text-muted">МП отдела к МП департамента B2B</small>
        </template>
      </b-card>
    </b-card-group>
    
    <b-card-group deck>
      <b-card 
        header-tag="header" 
        footer-tag="footer"
        no-body
      >
        <template #header>
          <h4 class="card-title mb-0">Новые запросы</h4>
        </template>

        <b-card-body class="p-0">
          <b-card-text class="middle-dashboard-cards">
            <template v-if="loading">
              <div class="my-5 text-center px-5">Ищем запросы...</div>
            </template>
            <template v-else>
              <template v-if="data.ordersNewRequests && data.ordersNewRequests.total > 0">
                <div 
                  class="card-item"
                  v-for="(item, item_key) in data.ordersNewRequests.items"
                  :key="item_key"
                >
                  <OrderKanbanItem
                    :item="item"
                    :noNames="true"
                    @click="openOrder"
                  ></OrderKanbanItem>
                </div>
              </template>
              <template v-else>
                <div class="my-5 text-center px-5">Нет новых запросов</div>
              </template>
            </template>
          </b-card-text>
        </b-card-body>

        <template #footer>
          <em>Кол-во для отработки: <b>{{ data.ordersNewRequests.total }}</b></em>
        </template>
      </b-card>
      
      <b-card 
        header-tag="header" 
        footer-tag="footer"
        no-body
      >
        <template #header>
          <h4 class="card-title mb-0">Связаться с клиентами</h4>
        </template>

        <b-card-body class="p-0">
          <b-card-text class="middle-dashboard-cards">
            <template v-if="loading">
              <div class="my-5 text-center px-5">Ищем задачи по связи с клиентами...</div>
            </template>
            <template v-else>
              <template v-if="data.tasksClientConnect && data.tasksClientConnect.length > 0">
                <div 
                  class="card-item"
                  v-for="(task, task_key) in data.tasksClientConnect"
                  :key="task_key"
                >
                  <TaskKanbanItem
                    :item="task"
                    :noNames="true"
                    @click="openTaskSidebar(task)"
                  ></TaskKanbanItem>
                </div>
              </template>
              <template v-else>
                <div class="my-5 text-center px-5">Нет задач, запланируйте!</div>
              </template>
            </template>
          </b-card-text>
        </b-card-body>

        <template #footer>
          <em>Кол-во для отработки: <b>{{ data.tasksClientConnect.length }}</b></em>
        </template>
      </b-card>
      
      <b-card 
        header-tag="header" 
        footer-tag="footer"
        no-body
      >
        <template #header>
          <h4 class="card-title mb-0">Ближайшие встречи</h4>
        </template>

        <b-card-body class="p-0">
          <b-card-text class="middle-dashboard-cards">
            <template v-if="loading">
              <div class="my-5 text-center px-5">Ищем задачи на встречи...</div>
            </template>
            <template v-else>
              <template v-if="data.tasksClientMeetings && data.tasksClientMeetings.length > 0">
                <div 
                  class="card-item"
                  v-for="(task, task_key) in data.tasksClientMeetings"
                  :key="task_key"
                >
                  <TaskKanbanItem
                    :item="task"
                    :noNames="true"
                    @click="openTaskSidebar(task)"
                  ></TaskKanbanItem>
                </div>
              </template>
              <template v-else>
                <div class="my-5 text-center px-5">Нет встреч, запланируйте!</div>
              </template>
            </template>
          </b-card-text>
        </b-card-body>

        <template #footer>
          <em>Кол-во для отработки: <b>{{ data.tasksClientMeetings.length }}</b></em>
        </template>
      </b-card>
      
      <b-card 
        header-tag="header" 
        footer-tag="footer"
        no-body
      >
        <template #header>
          <h4 class="card-title mb-0">Другие задачи</h4>
        </template>

        <b-card-body class="p-0">
          <b-card-text class="middle-dashboard-cards">
            <template v-if="loading">
              <div class="my-5 text-center px-5">Ищем задачи...</div>
            </template>
            <template v-else>
              <template v-if="data.tasksOtherType && data.tasksOtherType.length > 0">
                <div 
                  class="card-item"
                  v-for="(task, task_key) in data.tasksOtherType"
                  :key="task_key"
                >
                  <TaskKanbanItem
                    :item="task"
                    :noNames="true"
                    @click="openTaskSidebar(task)"
                  ></TaskKanbanItem>
                </div>
              </template>
              <template v-else>
                <div class="my-5 text-center px-5">Нет задач, запланируйте!</div>
              </template>
            </template>
          </b-card-text>
        </b-card-body>

        <template #footer>
          <em>Кол-во для отработки: <b>{{ data.tasksOtherType.length }}</b></em>
        </template>
      </b-card>

    </b-card-group>

    <tsoft-order-list
      v-if="orderList && orderList.length > 0"
      :openOrderList="openOrderList"
      :orderList="orderList"
      :label="orderListLabel"
      @closeOrderList="closeOrderList"
    >
    </tsoft-order-list> 
    
    <tsoft-finance-list
      v-if="financeList && financeList.length > 0"
      :openFinanceList="openFinanceList"
      :financeList="financeList"
      :label="financeListLabel"
      :need-group="openFinanceGroupedByOrder"
      :cbr="cbr"
      @closeFinanceList="closeFinanceList"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import OrderKanbanItem from "@components/orderKanban/OrderKanbanItem";
import TaskKanbanItem from "@components/task/TaskKanbanItem";
import OrderList from '@/components/orders/OrderList';
import FinanceList from '@/components/finance/FinanceList';
import { openTaskSidebar } from '@/mixins/openTaskSidebar';
import SalesChart from '@components/dashboards/charts/SalesChart';
import VueSpeedometer from "vue-speedometer";
import { toShortMillions } from "@/mixins/textFilters";

import {
    API_POST_USER_ACTION_HISTORY,
    API_ORDERS,
    API_POST_USER_DASHBOARD_TASKS,
    API_POST_USER_DASHBOARD_ORDERS_IN_WORK,
    API_POST_USER_DASHBOARD_ORDERS_CLOSED,
    API_POST_USER_DASHBOARD_MARGIN_PROFIT,
    API_POST_USER_DASHBOARD_MARGIN_PROFIT_COMPANY
} from "@/constants";


export default {
  props: {
    noNames: { type: Boolean, default: false },  // need names in cards or not
    loading: { type: Boolean, default: false },
  },
  components: {
    OrderKanbanItem,
    TaskKanbanItem,
    SalesChart,
    "tsoft-order-list": OrderList,
    "tsoft-finance-list": FinanceList,
    VueSpeedometer
  },
	mixins: [
		openTaskSidebar,
    toShortMillions
	],
  data() {
    return {
      history: {},  
      dashboardData: {
        ordersInWork: {},
        suppliesInWork: {},
        ordersClosed: {},
        marginProfit: {},
        marginProfitCompany: {
          'by-departments': {
            1: { total: 0 },
            2: { total: 0 }, 
            3: { total: 0 }, 
            6: { total: 0 }, 
          },
          'by-users' : { },
          'items' : { total: 0 }
        }
      },
      workWithRoles: 'logistics-head-manager,logistics-manager',
      workWithDepartmentId: 3,
      WorkWithKanbanType: 'logistics',
      workWithReferenceStatusId: 539,
      upCards: [
        'ordersInWork', 'suppliesInWork', 'ordersClosed', 'marginProfit'
      ],
      upCharts: [
        'ordersInWork', 'suppliesInWork', 'ordersClosed', 'marginProfit'
      ],
      personalGoals: [
        {
          title: "Новые клиенты",
          goal: 5,
          value: 0,
          typeStatus: "secondary",
          inTime: "в день",
          backendName: "new_company_responsibility"
        },
        {
          title: "Новые встречи",
          goal: 8,
          value: 0,
          typeStatus: "secondary",
          inTime: "в месяц",
          backendName: "tasks_new_meeting"
        },
        {
          title: "Новые договора",
          goal: 4,
          value: 0,
          typeStatus: "secondary",
          inTime: "в месяц",
          backendName: "dogovor"
        },
        {
          title: "Новые поставки",
          goal: 4,
          value: 0,
          typeStatus: "secondary",
          inTime: "в месяц",
          backendName: "order_to_supply"
        },
      ],
      data: {
        ordersNewRequests: {
          items: [], 
          total: 0
        },
        tasksClientMeetings: [],
        tasksClientConnect: [],
        tasksOtherType: []
      },
      orderList: [],
      openOrderList: false,
      orderListLabel: '',
      openFinanceList: false,            // Open sidebar with Finance List
      financeList: [],                   // Finance list for sidebar
      financeListLabel: '',              // Title of sidebar with data for finance
      openFinanceGroupedByOrder: false,
      cbr: {}
    }
  },
  computed: {
    ...mapGetters('auth', ['currentUser']),
  },  
  watch: {
    loading(val) {
      if (val) {
        this.refreshHistory();
      }
    },
  },
  mounted() {
    this.refreshHistory();
  },    
  methods: {
    async getHistory() {
      await axios.post(`${API_POST_USER_ACTION_HISTORY}`)
          .then(({ data }) => {
              this.history = data;
          });
    }, 

    async getNewOrderRequests() {
      const request = {
          all_users_opened: false,
          kanban: true,
          kanban_type: this.WorkWithKanbanType,
          parent_column: true,
          reference_status_id: this.workWithReferenceStatusId,
          user_id: this.currentUser.id
      }

      await axios.get(`${API_ORDERS}`, { params: { ...request, q: '' } })
          .then(({ data }) => {
            this.data.ordersNewRequests = (data.data && data.total) ?  { items: data.data, total: data.total} : { items: [], total: 0};
          });
    },
    
    async getActualTasks() {
      await axios.post(`${API_POST_USER_DASHBOARD_TASKS}`)
          .then(({ data }) => {
            this.data.tasksClientMeetings = data['tasksClientMeetings'] ?? [];
            this.data.tasksClientConnect = data['tasksClientConnect'] ?? [];
            this.data.tasksOtherType = data['tasksOtherType'] ?? [];
          });
    },

    async getOrdersInWork() {
      await axios.post(`${API_POST_USER_DASHBOARD_ORDERS_IN_WORK}`, { 
          roles: this.workWithRoles
        })
          .then(({ data }) => {
              this.dashboardData.ordersInWork = data['orders-in-work'] ?? {};
              this.dashboardData.suppliesInWork = data['supplies-in-work'] ?? {};
          });
    }, 
    
    async getOrdersClosed() {
      await axios.post(`${API_POST_USER_DASHBOARD_ORDERS_CLOSED}`, { 
          roles: this.workWithRoles
        })
          .then(({ data }) => {
              this.dashboardData.ordersClosed = data['orders-closed'] ?? {};
          });
    }, 

    async getMarginProfit() {
      await axios.post(`${API_POST_USER_DASHBOARD_MARGIN_PROFIT}`, { 
          roles: this.workWithRoles
        })
          .then(({ data }) => {
              this.dashboardData.marginProfit = data['margin-profit'] ?? {};
          });
    }, 

    async getMarginProfitCompany() {
      await axios.post(`${API_POST_USER_DASHBOARD_MARGIN_PROFIT_COMPANY}`, { 
        })
          .then(({ data }) => {
              this.dashboardData.marginProfitCompany = data['margin-profit-company'] ?? {};
          });
    }, 

    refreshHistory() {
      Promise.all([this.getHistory(), this.getNewOrderRequests(), this.getActualTasks(), this.getOrdersInWork(), this.getOrdersClosed(), this.getMarginProfit(), this.getMarginProfitCompany()]).then(() => {
        this.renderPersonalGoals();
        this.$emit('isUpdated', false);
      });
    },

    openOrder(id) {
      this.$router.push({
        path: `${this.$route.path}`,
        query: { 
          ...this.$route.query,
          order: id 
        },
      });
      setTimeout(() => {
        this.$root.$emit('bv::toggle::collapse', 'sidebar-right-order');
      }, 0)
    },
    showByIds(ids, type = 'orders', label = 'Список', order_to_manager = null) {
      if (type == 'orders') {
        this.orderList = ids;
        this.orderListLabel = label;
        this.openOrderList = true;
      }
      if (type == 'finance') {
      //   this.order_to_manager = order_to_manager;
      //   this.financeList = ids
      //   this.financeListLabel = label
      //   this.openFinanceList = true
      // }
      // if (type == 'financeGroupedByOrder') {
        this.financeList = ids
        this.financeListLabel = label
        this.openFinanceList = true
        this.openFinanceGroupedByOrder = true
      }
    },
    closeOrderList() {
      this.orderList = [];
      this.openOrderList = false;
    },
    closeFinanceList() {
      this.financeList = []
      this.openFinanceList = false
      this.openFinanceGroupedByOrder = false
    },
    renderPersonalGoals() {
      for(let key in this.personalGoals) {
        let historyKey = this.personalGoals[key].backendName;
        if (this.history[historyKey]) {
          this.personalGoals[key].value = this.history[historyKey].length;
          if (this.personalGoals[key].value >= (this.personalGoals[key].goal / 2)) {
            this.personalGoals[key].typeStatus = 'warning';
          }
          // Больше чем 90%
          if (this.personalGoals[key].value >= (this.personalGoals[key].goal * 90 / 100)) {
            this.personalGoals[key].typeStatus = 'success';
          }
        }
      }
    }, 
  },
}
</script>

<style scoped>
  .bigNumber {
    font-size: 28px;
  }
  @media (min-width: 576px) {
    .myBCardDeck {
      overflow: auto;
      max-width: 100%;
      padding-bottom: 15px;
      flex-wrap: nowrap;
    }
  
    .myBCardDeck::-webkit-scrollbar {
        width: 13px;
        height: 7px;
        background-color: #e1e1e1;
        border-radius: 4px !important;
    }

    .myBCardDeck::-webkit-scrollbar-thumb {
      background-color: #cbcaca;
    }
  
    .myBCardDeck::-webkit-scrollbar-track {
      background-color: #cbcaca;
    }
  

    .middle-dashboard-cards {
      min-height: 400px;
      max-height: 400px;
      overflow: auto;
    }

    .middle-dashboard-cards::-webkit-scrollbar {
      width: 7px;
      height: 13px;
      background-color: #e1e1e1;
      border-radius: 4px !important;
    }
    .middle-dashboard-cards::-webkit-scrollbar-thumb {
      background-color: #cbcaca;
    }

    .middle-dashboard-cards::-webkit-scrollbar-track {
      background-color: #cbcaca;
    }

  }  
</style>